var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import ReactSelect from 'react-select/async-creatable';
import Button from '@mui/material/Button';
import debounce from 'lodash/debounce';
import isEmpty from 'lodash/isEmpty';
import EachFilter from '../eachFilter/EachFilter';
import LoadingButton from '../mui/LoadingButton';
export var CourseFinderSearchCustomClickMappingKeys;
(function (CourseFinderSearchCustomClickMappingKeys) {
    CourseFinderSearchCustomClickMappingKeys["COURSE_SEARCH_ON_FOCUS"] = "COURSE_SEARCH_ON_FOCUS";
    CourseFinderSearchCustomClickMappingKeys["FIND_COURSES_ON_CLICK"] = "FIND_COURSES_ON_CLICK";
    CourseFinderSearchCustomClickMappingKeys["SELECT_COURSE_FROM_LIST"] = "SELECT_COURSE_FROM_LIST";
    CourseFinderSearchCustomClickMappingKeys["CREATE_NEW_COURSE"] = "CREATE_NEW_COURSE";
    CourseFinderSearchCustomClickMappingKeys["CHECKBOX_FILTERS_CLICKED"] = "CHECKBOX_FILTERS_CLICKED";
})(CourseFinderSearchCustomClickMappingKeys || (CourseFinderSearchCustomClickMappingKeys = {}));
export var CourseFinderSearchCustomClickActionMappingKeys;
(function (CourseFinderSearchCustomClickActionMappingKeys) {
    CourseFinderSearchCustomClickActionMappingKeys["ON_FOCUS"] = "onFocus";
    CourseFinderSearchCustomClickActionMappingKeys["ON_CLICK"] = "onClick";
})(CourseFinderSearchCustomClickActionMappingKeys || (CourseFinderSearchCustomClickActionMappingKeys = {}));
var CourseFinderSearch = function (_a) {
    var value = _a.value, onChange = _a.onChange, filters = _a.filters, _b = _a.loadOptions, loadOptions = _b === void 0 ? function (value, callback) {
        // eslint-disable-next-line n/no-callback-literal
        callback([]);
    } : _b, _c = _a.loading, loading = _c === void 0 ? false : _c, customClicksMapper = _a.customClicksMapper, onFilterChange = _a.onFilterChange;
    var _d = __read(useState(value || {}), 2), state = _d[0], setState = _d[1];
    var _e = __read(useState({}), 2), error = _e[0], setError = _e[1];
    var _f = __read(useState(), 2), searchValue = _f[0], setSearchValue = _f[1];
    useEffect(function () {
        setState(value);
    }, [value]);
    var handleFilterChange = function (name, value) {
        var _a;
        setState(function (state) {
            var _a;
            return (__assign(__assign({}, state), (_a = {}, _a[name] = value, _a)));
        });
        !isEmpty(error) && handleValidation();
        onFilterChange === null || onFilterChange === void 0 ? void 0 : onFilterChange(__assign(__assign({}, state), (_a = {}, _a[name] = value, _a)));
    };
    var handleSearchChange = function (option, meta) {
        var _a, _b, _c;
        if (option === null || option === void 0 ? void 0 : option.__isNew__) {
            (_a = customClicksMapper === null || customClicksMapper === void 0 ? void 0 : customClicksMapper[CourseFinderSearchCustomClickMappingKeys === null || CourseFinderSearchCustomClickMappingKeys === void 0 ? void 0 : CourseFinderSearchCustomClickMappingKeys.CREATE_NEW_COURSE]) === null || _a === void 0 ? void 0 : _a.call(customClicksMapper, option === null || option === void 0 ? void 0 : option.label);
        }
        else {
            (_b = customClicksMapper === null || customClicksMapper === void 0 ? void 0 : customClicksMapper[CourseFinderSearchCustomClickMappingKeys === null || CourseFinderSearchCustomClickMappingKeys === void 0 ? void 0 : CourseFinderSearchCustomClickMappingKeys.SELECT_COURSE_FROM_LIST]) === null || _b === void 0 ? void 0 : _b.call(customClicksMapper);
        }
        setSearchValue(option);
        setState(__assign(__assign({}, state), { search: option === null || option === void 0 ? void 0 : option.value, newSearchValue: (_c = meta.option) === null || _c === void 0 ? void 0 : _c.__isNew__ }));
    };
    var handleValidation = function () {
        var error = {};
        if (!(state === null || state === void 0 ? void 0 : state.search)) {
            error.search = 'Course Name is Required';
        }
        filters.forEach(function (eachFilter) {
            var _a;
            if (eachFilter.required &&
                ((eachFilter.multiple && !((_a = state === null || state === void 0 ? void 0 : state[eachFilter.name]) === null || _a === void 0 ? void 0 : _a.length)) ||
                    (!eachFilter.multiple && !(state === null || state === void 0 ? void 0 : state[eachFilter.name])))) {
                error[eachFilter.name] = "".concat(eachFilter.name, " is Required");
            }
        });
        setError(error);
        return isEmpty(error);
    };
    var handleSearch = function () {
        var _a;
        (_a = customClicksMapper === null || customClicksMapper === void 0 ? void 0 : customClicksMapper[CourseFinderSearchCustomClickMappingKeys === null || CourseFinderSearchCustomClickMappingKeys === void 0 ? void 0 : CourseFinderSearchCustomClickMappingKeys.FIND_COURSES_ON_CLICK]) === null || _a === void 0 ? void 0 : _a.call(customClicksMapper);
        handleValidation() && onChange(state);
    };
    return (React.createElement("div", { className: "lfc-w-[948px] lfc-mx-auto lfc-bg-white lfc-rounded-lg lfc-p-4 lfc-shadow-md lfc-mt-6" },
        React.createElement("div", { className: "lfc-text-xl lfc-font-bold lfc-mb-4" }, "Search Courses"),
        React.createElement("span", { className: "lfc-flex lfc-w-full" },
            React.createElement(ReactSelect, { styles: {
                    input: function (base) {
                        return (__assign(__assign({}, base), { height: '38px', minHeight: '38px' }));
                    },
                    menu: function (baseStyles, state) {
                        return (__assign(__assign({}, baseStyles), { zIndex: 10 }));
                    }
                }, value: searchValue, loadOptions: debounce(loadOptions, 200), placeholder: "Enter student preferred course (eg: Marketing) and press \u201CEnter\u201D to search", className: "lfc-flex-grow lfc-mr-1 lfc-text-sm", onChange: handleSearchChange, isClearable: true, onFocus: function () { var _a; return (_a = customClicksMapper === null || customClicksMapper === void 0 ? void 0 : customClicksMapper[CourseFinderSearchCustomClickMappingKeys === null || CourseFinderSearchCustomClickMappingKeys === void 0 ? void 0 : CourseFinderSearchCustomClickMappingKeys.COURSE_SEARCH_ON_FOCUS]) === null || _a === void 0 ? void 0 : _a.call(customClicksMapper); } }),
            loading ? (React.createElement(LoadingButton, null)) : (React.createElement(Button, { variant: "contained", color: "primary", className: "lfc-h-12", sx: { textTransform: 'none' }, onClick: handleSearch }, "Find Courses"))),
        React.createElement("div", { className: "lfc-text-sm lfc-text-red-400 lfc-font-medium lfc-mt-4" }, error.search),
        React.createElement("div", { className: "lfc-grid lfc-grid-cols-4 lfc-mt-4" }, filters.map(function (eachFilter) { return (React.createElement(EachFilter, __assign({ showCount: false }, eachFilter, { key: eachFilter.name, externalError: error[eachFilter.name], value: state[eachFilter.name], onChange: handleFilterChange, isSearchable: false, isClearable: false, customClickForFilterOption: customClicksMapper === null || customClicksMapper === void 0 ? void 0 : customClicksMapper[CourseFinderSearchCustomClickMappingKeys === null || CourseFinderSearchCustomClickMappingKeys === void 0 ? void 0 : CourseFinderSearchCustomClickMappingKeys.CHECKBOX_FILTERS_CLICKED], customClickActionTypeForFilterOption: CourseFinderSearchCustomClickActionMappingKeys === null || CourseFinderSearchCustomClickActionMappingKeys === void 0 ? void 0 : CourseFinderSearchCustomClickActionMappingKeys.ON_FOCUS }))); }))));
};
export default CourseFinderSearch;
//# sourceMappingURL=CourseFinderSearch.js.map